import { useState } from "react";

export default function Testimonials() {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const testimonials = [
    {
      name: "Denise Butler",
      title: "Operations Director, Apex Manufacturing Ltd",
      quote:
        "Working with Charles Bell Consulting completely transformed our manufacturing operations. Charles and his team were not only knowledgeable but also incredibly easy to work with. We now operate with more efficiency and confidence!",
    },
    {
      name: "Jonathan Williams",
      title: "Architect, University of Michigan",
      quote:
        "Charles Bell Consulting helped us modernize our classroom space to support efficient learning. Their innovative approach transformed the entire facility.",
    },
    {
      name: "Kamil Mian",
      title: "Principal, Novum LLC",
      quote:
        "We were struggling with our internal process. Charles Bell Consulting helped us streamline our operations and improve our efficiency. They were not only knowledgeable but also incredibly easy to work with.",
    },
  ];

  const handlePrev = () => {
    setSelectedIndex(selectedIndex === 0 ? 0 : selectedIndex - 1);
  };

  const handleNext = () => {
    setSelectedIndex(
      selectedIndex === testimonials.length - 1
        ? testimonials.length - 1
        : selectedIndex + 1
    );
  };

  return (
    <div className="container relative py-16 md:py-[200px] flex lg:flex-row flex-col">
      {/* Quote Icons */}
      <img
        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image23-7a4b8a48-a6e9-403e-a1e9-dd647f88fd50.svg"
        alt="image 23"
        className="absolute w-10 md:w-auto top-[226px] md:top-[100px] left-[22px] md:left-[400px]"
      />
      <img
        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image22-f18e6d1a-176e-42f8-8d50-6aa8ea04bbef.svg"
        alt="image 22"
        className="absolute w-10 md:w-auto top-[226px] md:top-[100px] right-[22px]"
      />
      <div className="justify-start items-start flex-col md:flex-row flex gap-24 lg:gap-36">
        <div className="relative flex-col min-w-[275px] justify-start items-start gap-2 inline-flex">
          <div className="p-2 bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
            <div className="whitespace-nowrap text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
              TESTIMONIALS
            </div>
          </div>
          <div className="text-[#0e0e0e] text-2xl md:text-[32px] font-semibold font-primary leading-[41.60px]">
            Hear from <br /> Satisfied Clients
          </div>
          <img
            src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/image24-61cabfd2-cdd6-4cb0-b355-ee27a64b8177.svg"
            alt="image 24"
            className="absolute top-[31px] right-[50px]"
          />
        </div>
        <div className="h-[250px] md:h-[182px] flex-col relative justify-start items-start gap-4 inline-flex mb-20 md:mb-0">
          <div className="text-[#373737] lg:text-xl font-light font-primary leading-7 tracking-[0.01em]">
            {testimonials[selectedIndex].quote}
          </div>
          <div className="h-[54px] flex-col justify-start items-start gap-1 flex">
            <div className="text-[#373737] lg:text-xl font-normal font-primary leading-7 tracking-[0.01em]">
              {testimonials[selectedIndex].name}
            </div>
            <div className="text-[#373737] text-base font-light font-primary leading-[22.40px] tracking-[0.01em]">
              {testimonials[selectedIndex].title}
            </div>
          </div>
          {/* Arrows icon */}
          <div className="absolute bottom-[-85px] md:bottom-[-135px] lg:bottom-[-100px] flex gap-[20px]">
            <img
              src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame75-cbbd7b71-4f2b-4789-82ce-7959777b929c.svg"
              alt="Frame 75"
              onClick={handlePrev}
              className={`cursor-pointer ${
                selectedIndex === 0 ? "opacity-50" : "opacity-100"
              }`}
            />
            <img
              src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame76-976c95e5-582b-48b6-b9b4-37b80a081f7c.svg"
              alt="Frame 76"
              onClick={handleNext}
              className={`cursor-pointer ${
                selectedIndex === testimonials.length - 1
                  ? "opacity-50"
                  : "opacity-100"
              }`}
            />
          </div>
        </div>
        {/* Bookmark Icon */}
        <img
          src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Rectangle1-f34482f9-081e-41f5-906b-30ec5104279c.svg"
          alt="Rectangle 1"
          className="absolute top-0 left-[22px] w-10 md:w-auto"
        />
      </div>
    </div>
  );
}
